import { setSelectedLocations, store } from "@redux";
import { clearSharedToken, logout, removeJwt, resetCart, resetSavedCart } from "@redux";
import { ssPathname } from "./storage";
import { DEFAULT_COUNTRY } from "@constants";

export const performLogoutActions = async () => {
    ssPathname.removeItem();
    await store.dispatch(logout());
    await store.dispatch(removeJwt());
    store.dispatch(clearSharedToken());
    store.dispatch(resetSavedCart());
    store.dispatch(resetCart());
    store.dispatch(
        setSelectedLocations({
            country: DEFAULT_COUNTRY,
            state: null,
            region: null,
            locality: null,
        }),
    );
};
